import { Fragment, useState } from "react"

// ** Third Party Components
import { Add } from "iconsax-reactjs"
import { matchPath, useLocation, useNavigate } from "react-router-dom"

// ** Routes
import {
  NEW_DASHBOARD_PAGE_ROUTE,
  PINNED_PROJECT_PAGE_ROUTE,
  PROJECT_PAGE_ROUTE,
  USER_PAGE_ROUTE,
} from "@pma/utils/page-routes"

// ** Hooks
import useTranslator from "@pma/hooks/use-translator"

// ** Custom Components
import QuickActions from "./QuickActions"
import NotificationForm from "./NotificationForm"
import HeaderBreadcrumbs from "./HeaderBreadcrumbs"

interface LeftSectionProps {
  onMenuClick?: () => void
}

const LeftSection = ({ onMenuClick }: LeftSectionProps) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { translate } = useTranslator()

  const [showNotificationForm, setShowNotificationForm] = useState(false)

  // Hide QuickActions on user detail route (e.g. /v1/users/:userId), like settings routes
  const isUserDetailRoute =
    location.pathname.startsWith(`${USER_PAGE_ROUTE}/`) &&
    location.pathname.replace(`${USER_PAGE_ROUTE}/`, "").length > 0

  // Show "Add Form" button only on project detail routes
  const isTaskView = (() => {
    const isPinnedDetail = Boolean(
      matchPath(`${PINNED_PROJECT_PAGE_ROUTE}/:projectId`, location.pathname),
    )
    if (isPinnedDetail) return true
    if (location.pathname.startsWith(PINNED_PROJECT_PAGE_ROUTE)) return false
    return Boolean(matchPath(`${PROJECT_PAGE_ROUTE}/:projectId`, location.pathname))
  })()

  return (
    <Fragment>
      <div
        className='flex cursor-pointer gap-2 md:hidden'
        onClick={() => navigate(NEW_DASHBOARD_PAGE_ROUTE, { replace: true })}
      >
        <div className='h-6 w-6 rounded-lg bg-neutral-600' />
        <p className='font-[inter] font-medium text-neutral-900'>ROG</p>
      </div>
      <div className='items-center gap-4 md:flex'>
        {!location.pathname.includes("setting") && !isUserDetailRoute ? (
          <div className='hidden md:block'>
            <QuickActions />
          </div>
        ) : null}
        {isTaskView ? (
          <button
            type='button'
            onClick={() => setShowNotificationForm(true)}
            className='hidden items-center gap-2 rounded-full border border-solid border-transparent bg-white px-4 py-2.5 font-[inter] text-sm font-bold text-purple-600 transition-colors md:flex'
            style={{
              backgroundImage:
                "linear-gradient(#fff, #fff), radial-gradient(109.91% 126.55% at 13.06% 22.92%, #7A5AF8 30.95%, #6938EF 65.87%)",
              backgroundOrigin: "border-box",
              backgroundClip: "padding-box, border-box",
            }}
          >
            <Add className='h-5 w-5 text-purple-600' />
            <span>{translate("Add Form")}</span>
          </button>
        ) : null}
        <div className='hidden md:block'>
          <HeaderBreadcrumbs />
        </div>
      </div>

      {showNotificationForm ? (
        <NotificationForm
          open={showNotificationForm}
          onClose={() => setShowNotificationForm(false)}
        />
      ) : null}
    </Fragment>
  )
}

export default LeftSection
